export default {
      id: "activities-usage",
      viewBox: "0 0 22 20",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#activities",
      toString: function () {
        return this.url;
      }
    }